import { useFormSelector } from 'mrf/redux/ReduxHelper';
import { Col, Grid } from 'mrf/view/Grid';
import Report from 'mrf/view/Report';
import {useTranslation} from "react-i18next";
import dateFormatter from 'mrf/utils/DateFormatter';
import DateField from 'mrf/view/DateField';
import FetcherObjectSelect from 'mrf/view/FetcherObjectSelect';

export default function CommunicationTransfersReport({ history, match }) {

    const context = useFormSelector({
        resource: 'communicationTransfersReport',
    });

    const {t} = useTranslation();

    const tableFields = [
        {name: t('Trasnfer Code'), key: ['id']},
        {name: t('Transfer Status'), keys: ['currentProcessStatus', 'name'], map:t},
        {name: t('Importing Country'), keys: ['importingCountry','institution','country','name']},
        {name: t('Exporting Country'), keys: ['exportingCountry','institution','country','name']},
        { name: t('Created at'), key: 'recordTimestamp', map: dateFormatter },
    ];

    const fields = [{ name: t('Name'), key: 'name'}];
    

    return <Report
        match={match}
        context={context}
        history={history}
        title={t('Communication Transfers Report')}
        tableFields={tableFields}
    >
        <Grid>
            <Col size={6}>
                <DateField
                    label={t('Start Date')}
                    field='startDate'
                />
            </Col>
            <Col size={6}>
                <DateField
                    label={t('Finish Date')}
                    field='finishDate'
                />
            </Col>
            <Col size={6}>
                <FetcherObjectSelect
                    label={t('Importing Country')}
                    resource='countries'
                    field='importingCountryId'
                    displayAttribute='name'
                    fields= {fields}
                />
            </Col>
            <Col size={6}>
                <FetcherObjectSelect
                    label={t('Exporting Country')}
                    resource='countries'
                    field='exportingCountryId'
                    displayAttribute='name'
                    fields= {fields}
                />
            </Col>
            <Col size={4}>
                <FetcherObjectSelect
                    label={t('Transfer Status')}
                    field='currentProcessStatusId'
                    resource='communicationProcessStatus'
                    displayAttribute='name'
                    fields= {fields}
                />
            </Col>
        </Grid>
    </Report>
}